import React, { useEffect, useRef } from 'react';
import maplibregl from 'maplibre-gl';
import 'maplibre-gl/dist/maplibre-gl.css';

const MapWorld = ({ setMapObject, mini }) => {
    const mapContainerRef = useRef(null);
    const mapRef = useRef(null);

    useEffect(() => {
        if (!mapContainerRef.current || mapRef.current) return;

        mapRef.current = new maplibregl.Map({
            container: mapContainerRef.current,
            style: 'https://map.alertes-speciales.fr/styles/france-style/style.json',
            center: [2.6352223054664137, 46.49538795629496],
            zoom: 5.5,
            antialias: true,
            rollEnabled: true,
        });

        setMapObject(mapRef.current);

        mapRef.current.on('load', () => {
            mapRef.current.resize();
        });

        return () => mapRef.current.remove();
    }, []);

    return (
        <div
            ref={mapContainerRef}
            className='map'
            style={{ width: '100%', height: mini ? '50vh' : '100vh' }}
        ></div>
    );
};

export default MapWorld;
